import { NarratorNPC } from '../../../../src/feature/narrator/narrator.model';
import { dialog } from './dialog';

export const innKeeper: NarratorNPC = {
  id: 'innkeeper',
  name: 'Waitress',
  dialog: dialog,
};
